import { DirectUpload } from '@rails/activestorage'

export default class AttachmentUpload {
  constructor(
    attachment,
    url,
    onUploadEnd,
    updateXHR,
    editorId,
    liveChatApp = false,
  ) {
    this.attachment = attachment
    this.onUploadEnd = onUploadEnd
    this.editorId = editorId
    this.upload = new DirectUpload(attachment.file, url, this)
    this.updateXHR = updateXHR
    this.liveChatApp = liveChatApp
  }

  start() {
    const onUploadEndWrapper = (error, attributes) => {
      if (!error) {
        return this.onUploadEnd(
          this.editorId,
          this.attachment,
          error,
          attributes,
        )
      }
    }
    this.upload.create(onUploadEndWrapper)
  }

  onLoad = (event) => {
    const error = event.currentTarget.response.error
    if (error) {
      this.onUploadEnd(this.editorId, this.attachment, error)
    }
  }

  onError = (event) => {
    const error = {
      error_message: 'An unexpected error occurred while uploading file',
      status: event.currentTarget.status,
    }
    this.onUploadEnd(this.editorId, this.attachment, error)
  }

  directUploadWillCreateBlobWithXHR(xhr) {
    if (this.liveChatApp) {
      const jwt = localStorage.getItem(window.speakeasyData.jwtLsId)
      xhr.setRequestHeader('AUTHORIZATION', `Bearer ${jwt}`)
    }
    xhr.addEventListener('load', this.onLoad)
    xhr.addEventListener('error', this.onError)
  }

  directUploadWillStoreFileWithXHR(xhr) {
    xhr.addEventListener('load', this.onLoad)

    xhr.upload.addEventListener('progress', (event) => {
      const progress = (event.loaded / event.total) * 100
      this.attachment.setUploadProgress(progress)
    })
    this.updateXHR(this.attachment, xhr)
    xhr.addEventListener('error', this.onError)
  }
}
